import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { api } from "@/lib/api";
import { Award, HeartHandshake, ShieldCheck, Stethoscope, MessageCircle } from "lucide-react";

const VALUES = [
  { icon: HeartHandshake, title: "Compassion first", body: "Every pet is met with patience and gentle handling." },
  { icon: ShieldCheck, title: "Evidence-based", body: "Modern diagnostics and treatment grounded in current science." },
  { icon: Award, title: "Owner partnership", body: "We treat you as part of the care team — transparent and honest." },
];

export default function About() {
  const [settings, setSettings] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)); }, []);

  return (
    <div className="min-h-screen ankara" data-testid="about-page">
      <Header />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 md:pt-20 pb-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-6">
          <div className="chip chip-emerald mb-3">Meet the veterinarian</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.05]">
            Dr. Juwon — <span className="italic text-[#0F766E]">care for every pet.</span>
          </h1>
          <p className="mt-6 text-[#57534E] leading-relaxed">
            Dr. Juwon is the owner and lead veterinary professional at <b>Jay's Veterinary Consult and Services</b>.
            With professional training in veterinary medicine from the <b>University of Ibadan</b>, Dr. Juwon is committed to providing
            reliable, compassionate, and evidence-based veterinary care while helping pet owners make informed decisions about their animals' health and wellbeing.
          </p>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {VALUES.map((v) => (
              <div key={v.title} className="p-5 bg-white border border-[#EAD9B0] rounded-2xl">
                <v.icon size={20} className="text-[#0F766E]" />
                <div className="font-display text-lg mt-2">{v.title}</div>
                <p className="text-sm text-[#57534E] mt-1">{v.body}</p>
              </div>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/consult" className="btn-primary px-6 py-3 rounded-full text-sm font-semibold inline-flex items-center gap-2" data-testid="about-consult-btn">
              <Stethoscope size={16} /> Book a Consultation
            </Link>
            <a href="https://wa.me/2348139771270" target="_blank" rel="noopener noreferrer" className="btn-whatsapp px-6 py-3 rounded-full text-sm font-semibold inline-flex items-center gap-2" data-testid="about-whatsapp-btn">
              <MessageCircle size={16} /> WhatsApp Dr. Juwon
            </a>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="rounded-[2rem] overflow-hidden aspect-[4/5] border-4 border-[#D4A017] shadow-xl bg-gradient-to-br from-[#0F766E] via-[#C2410C] to-[#D4A017]" data-testid="dr-photo">
            {settings.owner_photo_url ? (
              <img src={settings.owner_photo_url} alt="Dr. Juwon" className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex flex-col items-center justify-center text-white p-6 text-center">
                <div className="h-32 w-32 rounded-full bg-white/20 border-2 border-white/40 flex items-center justify-center font-display text-6xl mb-4">J</div>
                <div className="font-display text-2xl">Dr. Juwon</div>
                <div className="text-xs uppercase tracking-widest mt-2 opacity-90">DVM · University of Ibadan</div>
                <p className="mt-4 text-xs max-w-xs opacity-85">Owner and lead veterinary professional.</p>
                <div className="mt-6 text-[10px] bg-black/30 px-3 py-1 rounded-full">Photo placeholder — admin can upload</div>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
